import React, { useState, useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';

const BASE_URL = 'https://whapi.infosware-test.in'; // Define base URL

function WareHouseForm({ registerTag, onCancel, onSave }) {
    const [formData, setFormData] = useState({
        id: '',
        name: '',
        address: '',
        ip: '',
    });

    useEffect(() => {
        if (registerTag) {
            setFormData(registerTag);
        }
    }, [registerTag]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            let response;
            if (formData.id) {
                response = await fetch(`${BASE_URL}/warehouses/${formData.id}`, {
                    method: 'PUT',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });
            } else {
                response = await fetch(`${BASE_URL}/warehouses`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                });
            }

            const data = await response.json();

            if (response.ok) {
                alert('Warehouse saved successfully!');
                setFormData({ id: '', name: '', address: '', ip: '' }); // Reset form
                onSave(data); // Pass the saved data to the parent component
            } else {
                alert(`Error: ${data.message}`);
            }
        } catch (error) {
            console.error('Error saving warehouse:', error);
            alert('Failed to save warehouse. Please try again.');
        }
    };

    return (
        <div>
            <h3 className='mt-1 p-4 bg-secondary text-white'>{registerTag ? 'Edit Warehouse' : 'New Warehouse'}</h3>
            <Form className='container p-4 mb-4 shadow-sm rounded bg-white' onSubmit={handleSubmit}>
                <Form.Group controlId="name">
                    <Form.Label>WareHouse Name :</Form.Label>
                    <Form.Control type="text" name="name" value={formData.name} onChange={handleChange} required />
                </Form.Group>
                <Form.Group controlId="address">
                    <Form.Label>Address :</Form.Label>
                    <Form.Control type="text" name="address" value={formData.address} onChange={handleChange} required />
                </Form.Group>
                <Form.Group controlId="ip">
                    <Form.Label>IP Address :</Form.Label>
                    <Form.Control type="text" name="ip" value={formData.ip} onChange={handleChange} required />
                </Form.Group>

                <Button className='mt-3' variant="danger" onClick={onCancel}>Back</Button>{' '}
                <Button className='mt-3' variant="primary" type="submit">Save</Button>
            </Form>
        </div>
    );
}

export default WareHouseForm;
